import React from 'react'

import { Stack, StackProps } from '../Stack'
import { IconButton } from '../IconButton'
import { Text } from '../Text'

export interface PaginationControlsProps extends StackProps {
  isFetching?: boolean
  totalPages: number
  onPageChange?: () => void
  pagination: {
    hasNextPage: boolean
    hasPrevPage: boolean
    page: number
    onPrevPage: () => void
    onNextPage: () => void
  }
}

export const PaginationControls = ({
  pagination,
  isFetching = false,
  totalPages,
  onPageChange,
  ...restProps
}: PaginationControlsProps) => {
  return (
    <Stack isInline spacing={5} align="center" justify="center" {...restProps}>
      {totalPages > 1 && (
        <IconButton
          icon="chevron-left"
          fontSize="xl"
          isRound
          variantColor="pink"
          isDisabled={!pagination.hasPrevPage}
          isLoading={isFetching && pagination.hasPrevPage}
          onClick={() => {
            pagination.onPrevPage()
            onPageChange && onPageChange()
          }}
        />
      )}

      <Text textAlign="center">
        Page {pagination.page} of {totalPages}
      </Text>

      {totalPages > 1 && (
        <IconButton
          icon="chevron-right"
          fontSize="xl"
          isRound
          variantColor="pink"
          isDisabled={!pagination.hasNextPage}
          isLoading={isFetching && pagination.hasNextPage}
          onClick={() => {
            pagination.onNextPage()
            onPageChange && onPageChange()
          }}
        />
      )}
    </Stack>
  )
}

export default PaginationControls
